export enum EventsName {
  ENTITIES_CLICK = 'entitiesClick',
  RESOURCES_CLICK = 'resourcesClick',
}
